import { render, staticRenderFns } from "./PositionAssignmentsTable.vue?vue&type=template&id=2b78555f&scoped=true"
import script from "./PositionAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./PositionAssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./PositionAssignmentsTable.vue?vue&type=style&index=0&id=2b78555f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78555f",
  null
  
)

export default component.exports